(function () {
	'use strict';

	angular
		.module('portalApp')
		.controller('GlobalHeaderController', GlobalHeaderController);

	/**
	 * @ngInject
	 */
	function GlobalHeaderController($log, $state, $timeout, $document,
									appI18n, appConfig, appSession,
									configurationService, studySelectService, ssoService,
									globalHeaderService) {
		$log = $log.getInstance('GlobalHeaderController');
		$log.debug('loaded');

		var vm = this;

		var svgIcons = {
			'application-mode': `<svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"> 
			<path d="M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM448 96v64H64V96H448zM64 224h64V416H64V224zm384 0V416H192V224H448z" /> 
			</svg>`,
			'training-mode': `<svg viewBox="0 0 640 512" xmlns="http://www.w3.org/2000/svg"> 
			<path d="M320 32c-8.1 0-16.1 1.4-23.7 4.1L15.8 137.4C6.3 140.9 0 149.9 0 160s6.3 19.1 15.8 22.6l57.9 20.9C57.3 229.3 48 259.8 48 291.9v28.1c0 28.4-10.8 57.7-22.3 80.8c-6.5 13-13.9 25.8-22.5 37.6C0 442.7-.9 448.3 .9 453.4s6 8.9 11.2 10.2l64 16c4.2 1.1 8.7 .3 12.4-2s6.3-6.1 7.1-10.4c8.6-42.8 4.3-81.2-2.1-108.7C90.3 344.3 86 329.8 80 316.5V291.9c0-30.2 10.2-58.7 27.9-81.5c12.9-15.5 29.6-28 49.2-35.7l157-61.7c8.2-3.2 17.5 .8 20.7 9s-.8 17.5-9 20.7l-157 61.7c-12.4 4.9-23.3 12.4-32.2 21.6l159.6 57.6c7.6 2.7 15.6 4.1 23.7 4.1s16.1-1.4 23.7-4.1L624.2 182.6c9.5-3.4 15.8-12.5 15.8-22.6s-6.3-19.1-15.8-22.6L343.7 36.1C336.1 33.4 328.1 32 320 32zM128 408c0 35.3 86 72 192 72s192-36.7 192-72L496.7 262.6 354.5 314c-11.1 4-22.8 6-34.5 6s-23.5-2-34.5-6L143.3 262.6 128 408z" /> 
			</svg>`,
			'proficiency-mode': `<svg viewBox="0 0 384 512" xmlns="http://www.w3.org/2000/svg"> 
			<path d="M56.9 309.7L1.3 441.8c-2.2 5.3-1.4 11.4 2.1 16s9.3 6.9 15 6l56.1-8.3 32.2 49.2c3.2 5 8.9 7.7 14.8 7.2s11-4.3 13.3-9.7l50.1-119c-3.9-.9-7.6-2.4-11-4.7L156 366.8c-6-3.9-13-5.8-20.1-5.4l-21.3 1.3c-13.2 .8-25.6-6.4-31.5-18.2l-9.6-19.1c-3.2-6.4-8.4-11.5-14.7-14.7l-1.8-.9zm142.3 73.5l50.1 119c2.3 5.5 7.4 9.2 13.3 9.7s11.6-2.2 14.8-7.2l32.2-49.2 56.1 8.3c5.7 .8 11.4-1.5 15-6s4.3-10.7 2.1-16L327.1 309.7l-1.8 .9c-6.4 3.2-11.5 8.4-14.7 14.7L301 344.5c-5.9 11.8-18.3 19-31.5 18.2l-21.3-1.3c-7.1-.4-14.2 1.5-20.1 5.4l-17.8 11.8c-3.4 2.3-7.2 3.8-11 4.7z" />
			<path d="M210.2 5.5c-11-7.3-25.4-7.3-36.4 0L156 17.2c-6 3.9-13 5.8-20.1 5.4l-21.3-1.3c-13.2-.8-25.6 6.4-31.5 18.2L73.4 58.6C70.2 65 65 70.2 58.6 73.4L39.5 83c-11.8 5.9-19 18.3-18.2 31.5l1.3 21.3c.4 7.1-1.5 14.2-5.4 20.1L5.5 173.8c-7.3 11-7.3 25.4 0 36.4L17.2 228c3.9 6 5.8 13 5.4 20.1l-1.3 21.3c-.8 13.2 6.4 25.6 18.2 31.5l19.1 9.6c6.4 3.2 11.5 8.4 14.7 14.7L83 344.5c5.9 11.8 18.3 19 31.5 18.2l21.3-1.3c7.1-.4 14.2 1.5 20.1 5.4l17.8 11.8c11 7.3 25.4 7.3 36.4 0L228 366.8c6-3.9 13-5.8 20.1-5.4l21.3 1.3c13.2 .8 25.6-6.4 31.5-18.2l9.6-19.1c3.2-6.4 8.4-11.5 14.7-14.7l19.1-9.6c11.8-5.9 19-18.3 18.2-31.5l-1.3-21.3c-.4-7.1 1.5-14.2 5.4-20.1l11.8-17.8c7.3-11 7.3-25.4 0-36.4L366.8 156c-3.9-6-5.8-13-5.4-20.1l1.3-21.3c.8-13.2-6.4-25.6-18.2-31.5l-19.1-9.6c-6.4-3.2-11.5-8.4-14.7-14.7L301 39.5c-5.9-11.8-18.3-19-31.5-18.2l-21.3 1.3c-7.1 .4-14.2-1.5-20.1-5.4L210.2 5.5zM192 112a80 80 0 1 1 0 160 80 80 0 1 1 0-160z" /> 
			</svg>`,
			'sample-mode': `<svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"> 
			<path d="M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM188.3 147.1c-7.6 4.2-12.3 12.3-12.3 20.9V344c0 8.7 4.7 16.7 12.3 20.9s16.8 4.1 24.3-.5l144-88c7.1-4.4 11.5-12.1 11.5-20.5s-4.4-16.1-11.5-20.5l-144-88c-7.4-4.5-16.7-4.7-24.3-.5z"/>
			<path d="M212.5 147.5c-7.4-4.5-16.7-4.7-24.3-.5s-12.3 12.3-12.3 20.9V344c0 8.7 4.7 16.7 12.3 20.9s16.8 4.1 24.3-.5l144-88c7.1-4.4 11.5-12.1 11.5-20.5s-4.4-16.1-11.5-20.5l-144-88z" opacity=".1"/> 
			</svg>`,
			'client-uat': `<svg viewBox="0 0 448 512" xmlns="http://www.w3.org/2000/svg"> 
			<path d="M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM337 209L209 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L303 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"/><path d="M337 175c9.4 9.4 9.4 24.6 0 33.9L209 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L303 175c9.4-9.4 24.6-9.4 33.9 0z" opacity=".1" /> 
			</svg>`
		}

		vm.studyModeMenuAdded = false;

		var globalHeaderCss = `${appConfig.gsso.getNavigatorHeaderBaseUrl()}header.css`;
		var selector = `link[href='${globalHeaderCss}']`;

		if (!$(selector).length) {
			$('<link>').attr({ rel: 'stylesheet', type: 'text/css', href: globalHeaderCss}).appendTo('body');
		}

		const study = appSession.getStudy();
		let redirecting = false;

		if (study) {
			redirecting = ssoService.redirectToDashboardIfNotEmbedded(study.id, study.number);
		}

		if (redirecting) {
			$log.debug('direct redirect from globalHeader.js');
		} else {
			loadGlobalHeader();
		}

		function loadGlobalHeader() {
			if (!appSession.isValid()) {
				$log.debug('do not load header script: no valid session');
				return;
			}


			configurationService.checkSession().then((response) => {
				// make sure to only load header when session is stil valid
				// so that MSP3 can handle any session expiration itself, not let the header
				// handle it here
				$log.debug(`check session returns: ${response.data}`);
				if (response.data) {
					loadHeaderScript();
				} else {
					// handle session expiration
					appSession.handleSessionExpiration();
				}
			});
		}
		function loadHeaderScript() {
			if (!window.ertGlobalHeader && appConfig.gsso.useGlobalHeader) {

				window.ertGlobalHeaderReady = function () {
					return getGlobalHeaderReadyReturnState();
				};

				$log.debug('adding header script tag');
				var script = document.createElement('script');
				script.type = 'text/javascript';
				script.src = `${appConfig.gsso.getNavigatorHeaderBaseUrl()}header.js`;
				script.id = 'ert-global-header-script';
				script.setAttribute('data-client-id', 'msp3');
				document.body.appendChild(script);
			}
			activate();
		}

		function activate() {
			$log.debug('activate');
			if (!appSession.isValid()) {
				$log.debug('no valid session');
				return;
			}
			if (hasStudy()) {
				$log.debug('has study');
				configurationService.getUserStudySettings()
					.then(function (response) {
						updateGlobalHeader(response.data.studyConfig.studyModes);
					});
			}
			vm.hideGssoMenu = $state.current.name === appConfig.routes.contactCustomerCare;
		}

		function hasStudy() {
			var study = appSession.getStudy();
			return study !== null;
		}

		function updateGlobalHeader(modes) {
			$log.debug('update global header');
			var globalHeader = window.ertGlobalHeader;
			if (!globalHeader) {
				$log.debug("No global header yet");
				window.ertGlobalHeaderReady = function () {
					$timeout(() => updateGlobalHeader(modes));
					return getGlobalHeaderReadyReturnState();
				};
				return;
			}

			// send "header ready" signal
			globalHeaderService.setHeaderReady(true);

			// to be backward compatible we need to get the header height (0 or 50px)
			const gssoHeader = $document.find('#ert-global-header');
			const gssoHeaderHeight = (gssoHeader.length === 1 &&
									  gssoHeader[0].offsetHeight) || 0;

			$document.find('div.es-app')
				.css('min-height', `calc(100vh - ${gssoHeaderHeight}px)`);

			setLogoutCallback(globalHeader);
			addStudyModeDropDown(globalHeader, modes);
			registerClientRoot(globalHeader);

			$log.debug('done update global header');
		}

		function setLogoutCallback(globalHeader) {
			globalHeader.subscribe('logout', (done) => {
				$log.debug('gsso logout -> app session logout ');
				appSession.gssoLogout().then(() => {
					if (done) {
						done();
					}
				});
			});
		}

		function registerClientRoot(globalHeader) {
			// check if registerClientRoot is available
			if (globalHeader && globalHeader.registerClientRoot) {
				const study = appSession.getStudy();

				// to get the default landing page we can reuse the getStudySwitchConfig
				studySelectService.getStudySwitchConfig(study.id, study.studyModeId).then((response) => {
					const defaultRoute = appConfig.getRouteForModuleId(response.data.startingPageId);

					// the studySwitchConfig call considers all required cases (site admin,
					// starting page configured in PD, fallback to first available module)
					if (defaultRoute) {
						globalHeader.registerClientRoot(() => {
							$state.go(defaultRoute, {study: study.id, mode: study.studyModeId}, { inherit: false });
						});
					} else {
						$log.warn(`RegisterClientRoot - No starting page available.`);
					}
				});
			} else {
				$log.warn(`RegisterClientRoot - Registration failed. Parameters: globalHeader ${!!globalHeader}, registerClientRoot ${!!globalHeader.registerClientRoot}`);
			}
		}

		function getGlobalHeaderReadyReturnState() {
			const globalHeaderUpdateTime = appSession.getGlobalHeaderInitTime();
			const session = appSession.get();

			$log.debug('global header updatetime: ' + globalHeaderUpdateTime);
			$log.debug('session creation: ' + session.timestamp);

			const returnState = {};

			if (!globalHeaderUpdateTime || (+session.timestamp > +globalHeaderUpdateTime)) {
				returnState.idToken = appSession.getSessionToken();
				appSession.updateGlobalHeaderInitTime();
			}

			const study = appSession.getStudy();

			returnState.studyId = study.id;
			returnState.productCode = 'msp3';
			returnState.studyNumber = study.number;

			$log.debug('global header ready return: ' + JSON.stringify(returnState));
			return returnState;
		}

		function addStudyModeDropDown(globalHeader, modes, retryCount = 0) {
			const session = appSession.get();

			if (!session.state || !session.state.study) {
				const study = appSession.getStudy();

				globalHeader.createState(study.id, 'msp3').then((state) => {
					$log.debug(`set header state to ${state}`);

					globalHeader.setState(state);
					globalHeader.show();
				});
			}
			globalHeader.rendered(() => {
				$log.debug('global header there');
				$log.debug('controller thinks menu is already added: ' + vm.studyModeMenuAdded);
				$log.debug('globalheader thinks menu is already added: ' + globalHeader.msp3StudyModeDropdown);

				var translationKeys = [
					'header.mode.study',
					'header.mode.training',
					'header.mode.proficiency',
					'header.mode.sample',
					'header.mode.uat'
				];
					appI18n.translate(translationKeys).then(function(translations) {
					var currentMode = appSession.getStudyModeId();
					var icons = ['application-mode', 'training-mode', 'proficiency-mode', 'sample-mode', 'client-uat'];
					var menu = {
						label: translations[translationKeys[currentMode]],
						icon: svgIcons[icons[currentMode]]
					};
					if (currentMode !== 0) {
						menu.className = 'gh-training-mode';
					}
					menu.items = getStudyModeItems(modes, translationKeys, translations, icons, currentMode);
					const oldDropdown = globalHeader.msp3StudyModeDropdown;
					if (oldDropdown) {
						$log.debug('removing previous dropdown');
						globalHeader.removeWidget(oldDropdown);
						globalHeader.msp3StudyModeDropdown = null;
					}
					if (menu.items.length > 0) {
						var dd = globalHeader.addDropdown(2, menu);
						// remember dropdown. Cannot remember it in the controller, as the
						// controller is re-initialized.
						globalHeader.msp3StudyModeDropdown = dd;
						vm.studyModeMenuAdded = true;
							globalHeader.show();
					}
				});
			});
			if ($document[0].getElementById('ert-global-header')) {
				globalHeader.show();
			} else if (retryCount < 50) {
				$log.debug('no header element yet, retry later, try: ' + retryCount);
				$timeout(() => addStudyModeDropDown(globalHeader, modes, ++retryCount), 500);
			} else {
				// avoid infinite loop
				$log.error('still no header element found, no longer retrying');
			}
		}

		function switchStudyMode(mode) {
			appSession.switchStudyMode(mode);
		}

		function getStudyModeItems(modes, labelKeys, labels, icons, currentMode) {
			var dropDownItems = [];
			for (var i = 0; i < modes.length; ++i) {
				var modeId = modes[i];

				if (modeId === currentMode) {
					continue;
				}

				var item = {
					label: labels[labelKeys[modeId]],
					icon: svgIcons[icons[modeId]]
				};

				var svgProps = {
					width: '16',
					height: '16',
					fill: '#7d2d52'
				};

				function getStyledSvg(svgString) {
					let styledSvg = svgString.replace('<svg', `<svg width="${svgProps.width}" height="${svgProps.height}"`);
					return styledSvg.replace(/<path/g, `<path style="fill:${svgProps.fill} !important;"`);
				}



				(function (i) {
					var svgIcon = svgIcons[icons[modeId]] || svgIcons['application-mode'];
					var styledSvgIcon = getStyledSvg(svgIcon);
					var item2 = {
						events: [{
							type: 'click',
							selector: 'button',
							handler: (e) => {
								switchStudyMode(i);
							}
						}],
						html: '<a class="menu-item">' + '<span class="cluster">'+ styledSvgIcon + '<span>' + item.label + '</span></span></a>'
					};
					dropDownItems.push(item2);
				})(modeId);

			}

			return dropDownItems;
		}
	}

})();
